"use client";

import { useEffect, useRef } from "react";
import { cn } from "@/lib/format";

type Props = {
  open: boolean;
  onClose: () => void;
  label: string;
  side?: "left" | "right";
  className?: string;
  children: React.ReactNode;
};

// A native modal dialog, so focus trapping, Escape and background inertness
// come from the browser.
export function Drawer({ open, onClose, label, side = "right", className, children }: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      aria-label={label}
      className={cn("drawer", side === "left" && "drawer-left", className)}
      onClose={onClose}
      onClick={(event) => {
        // Clicks on the backdrop land on the dialog element itself.
        if (event.target === ref.current) onClose();
      }}
    >
      {children}
    </dialog>
  );
}
